import script from "./Right_UserProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./Right_UserProfile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__